import type { ReactNode } from 'react';

type RecognitionStripProps = {
  children: ReactNode;
};

const BORDER_GRADIENT = 'linear-gradient(to right, #FAFAFA, #CCCCCC, #FAFAFA)';

export function RecognitionStrip({ children }: RecognitionStripProps) {
  return (
    <div className="relative w-full py-[1.875rem]">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-px"
        style={{ background: BORDER_GRADIENT }}
      />
      {children}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 bottom-0 h-px"
        style={{ background: BORDER_GRADIENT }}
      />
    </div>
  );
}
